import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import('./views/Home.vue')
        },
        {
            path: '/buy',
            name: 'buy',
            component: () => import('./views/Buy.vue')
        },
        {
            path: '/buy-from-outsource/:id',
            name: 'buy-from-outsource',
            component: () => import('./views/BuyFromOutsource.vue'),
            props: (route) => ({
                ...route.params
            })
        },
        {
            path: '/buy-from-outsource-old/:id',
            name: 'buy-from-outsource-old',
            component: () => import('./views/BuyFromOutsourceOld.vue'),
            props: (route) => ({
                ...route.params
            })
        },
        {
            path: '/selectCustomer',
            name: 'selectCustomer',
            component: () => import('./views/SelectCustomer.vue'),
            props: (route) => ({
                ...route.params
            })
        },
        {
            path: '/sell',
            name: 'sell',
            component: () => import('./views/Sell.vue'),
            props: (route) => ({
                ...route.params
            })
        },
        {
            path: '/payment',
            name: 'payment',
            component: () => import('./views/Payment.vue'),
            props: (route) => ({
                ...route.params
            })
        },
        {
            path: '/products',
            name: 'products',
            component: () => import('./views/Products.vue')
        },
        {
            path: '/production',
            name: 'production',
            component: () => import('./views/Production.vue')
        },
        {
            path: '/productionSelectOutsource',
            name: 'productionSelectOutsource',
            component: () => import('./views/ProductionSelectOutsource.vue')
        },
        {
            path: '/productionFromOutsource',
            name: 'productionFromOutsource',
            component: () => import('./views/ProductionFromOutsource.vue')
        },
        {
            path: '/productionPayment',
            name: 'productionPayment',
            component: () => import('./views/ProductionPayment.vue')
        },
        {
            path: '/product-report',
            name: 'product-report',
            component: () => import('./views/Reports/ProductReport.vue')
        },
        {
            path: '/archives',
            name: 'archives',
            component: () => import('./views/Archives.vue')
        },
        {
            path: '/assign-product-to-provider/:id',
            name: 'assign-product-to-provider',
            component: () => import('./views/AssignProductToProvider.vue')
        },
        {
            path: '/headlines',
            name: 'headlines',
            component: () => import('./views/Headlines.vue'),
            children: [
                {
                    path: '/accountHead',
                    name: 'accountHead',
                    component: () => import('./views/Headlines/AccountHead.vue')
                },
                {
                    path: '/bank',
                    name: 'bank',
                    component: () => import('./views/Headlines/Bank.vue')
                },
                {
                    path: '/provider',
                    name: 'provider',
                    component: () => import('./views/Headlines/Provider.vue')
                },
                {
                    path: '/customer',
                    name: 'customer',
                    component: () => import('./views/Headlines/Customer.vue')
                },
                {
                    path: '/cash-desk',
                    name: 'cash-desk',
                    component: () => import('./views/Headlines/CashDesk.vue')
                },
                {
                    path: '/check-book',
                    name: 'check-book',
                    component: () => import('./views/Headlines/CheckBook.vue')
                },
                {
                    path: '/cost',
                    name: 'cost',
                    component: () => import('./views/Headlines/Cost.vue')
                },
                {
                    path: '/income',
                    name: 'income',
                    component: () => import('./views/Headlines/Income.vue')
                },
                {
                    path: '/category',
                    name: 'category',
                    component: () => import('./views/Headlines/Category.vue')
                },
                {
                    path: '/headline-products',
                    name: 'headline-products',
                    component: () => import('./views/Headlines/Products.vue')
                },
                {
                    path: '/headline-Units',
                    name: 'headline-Units',
                    component: () => import('./views/Headlines/Units.vue')
                },
            ]
        },
        {
            path: '/taxService',
            name: 'taxService',
            component: () => import('./views/TaxService.vue'),
            children: [
                {
                    path: '/register',
                    name: 'register',
                    component: () => import('./views/TaxService/Register.vue')
                },
                {
                    path: '/sellFactors',
                    name: 'sellFactors',
                    component: () => import('./views/TaxService/SellFactors.vue')
                },
                {
                    path: '/sentFactors',
                    name: 'sentFactors',
                    component: () => import('./views/TaxService/SentFactors.vue')
                },
                {
                    path: '/successFactors',
                    name: 'successFactors',
                    component: () => import('./views/TaxService/SuccessFactors.vue')
                },
            ]
        },
        {
            path: '/account',
            name: 'account',
            component: () => import('./views/Account.vue'),
            children: [
                {
                    path: '/saleMali',
                    name: 'saleMali',
                    component: () => import('./views/Account/SaleMali.vue')
                },
                {
                    path: '/closeSaleMali',
                    name: 'closeSaleMali',
                    component: () => import('./views/Account/CloseSaleMali.vue')
                },
                {
                    path: '/accountOutSource',
                    name: 'accountOutSource',
                    component: () => import('./views/Account/AccountOutSource.vue')
                },
                {
                    path: '/accountPayment',
                    name: 'accountPayment',
                    component: () => import('./views/Account/AccountPayment.vue')
                },
                {
                    path: '/accountPaymentList',
                    name: 'accountPaymentList',
                    component: () => import('./views/Account/AccountPaymentList.vue')
                },
                {
                    path: '/addPayment',
                    name: 'addPayment',
                    component: () => import('./views/Account/AddPayment.vue')
                },
                {
                    path: '/addCombine',
                    name: 'addCombine',
                    component: () => import('./views/Account/AddCombine.vue')
                },
                {
                    path: '/accountBalanceReport',
                    name: 'accountBalanceReport',
                    component: () => import('./views/Account/BalanceReport.vue')
                },
                {
                    path: '/accountCobine',
                    name: 'accountCobine',
                    component: () => import('./views/Account/AccountCobine.vue')
                },

            ]
        },
        {
            path: '/reports',
            name: 'reports',
            component: () => import('./views/Reports.vue'),
            children: [
                // {
                //     path: '/payment',
                //     name: 'payment',
                //     component: () => import('./views/Payment.vue'),
                //     props: (route) => ({
                //         ...route.params
                //     })
                // },
                {
                    path: '/buy-report',
                    name: 'buy-report',
                    component: () => import('./views/Reports/BuyReport.vue')
                },
                {
                    path: '/sell-report',
                    name: 'sell-report',
                    component: () => import('./views/Reports/SellReport.vue')
                },
                {
                    path: '/inventory',
                    name: 'inventory',
                    component: () => import('./views/Reports/Inventory.vue')
                },
                {
                    path: '/receive-report',
                    name: 'receive-report',
                    component: () => import('./views/Reports/Receive.vue')
                },
                {
                    path: '/payment-report',
                    name: 'payment-report',
                    component: () => import('./views/Reports/Payment.vue')
                },
                {
                    path: '/receive-check-report',
                    name: 'receive-check-report',
                    component: () => import('./views/Reports/ReceiveCheck.vue')
                },
                {
                    path: '/payment-check-report',
                    name: 'payment-check-report',
                    component: () => import('./views/Reports/PaymentCheckReport.vue')
                },
                {
                    path: '/book-report',
                    name: 'book-report',
                    component: () => import('./views/Reports/BookReport.vue')
                },
                {
                    path: '/balance-report',
                    name: 'balance-report',
                    component: () => import('./views/Account/BalanceReport.vue')
                },
                {
                    path: '/todayCheck',
                    name: 'todayCheck',
                    component: () => import('./views/Reports/TodayCheck.vue')
                },
                {
                    path: '/report-provider',
                    name: 'report-provider',
                    component: () => import('./views/Reports/Provider.vue')
                },
                {
                    path: '/report-customer',
                    name: 'report-customer',
                    component: () => import('./views/Reports/Customer.vue')
                },
                {
                    path: '/inventoryLessProduct',
                    name: 'inventoryLessProduct',
                    component: () => import('./views/Reports/InventoryLessProduct.vue')
                },

            ]
        },
        {
            path: '/dailyreports',
            name: 'dailyreports',
            component: () => import('./views/DailyReports.vue'),
            children: [
                {
                    path: '/dbuy-report',
                    name: 'dbuy-report',
                    component: () => import('./views/Reports/DBuyReport.vue')
                },
                {
                    path: '/dsell-report',
                    name: 'dsell-report',
                    component: () => import('./views/Reports/DSellReport.vue')
                },
                {
                    path: '/dinventory',
                    name: 'dinventory',
                    component: () => import('./views/Reports/DInventory.vue')
                },
                {
                    path: '/dreceive-report',
                    name: 'dreceive-report',
                    component: () => import('./views/Reports/DReceive.vue')
                },
                {
                    path: '/dpayment-report',
                    name: 'dpayment-report',
                    component: () => import('./views/Reports/DPayment.vue')
                },
                {
                    path: '/dbalance-report',
                    name: 'dbalance-report',
                    component: () => import('./views/Reports/DBalanceReport.vue')
                },

            ]
        },

        {
            path: '/archives',
            name: 'archives',
            component: () => import('./views/Archives.vue'),
            children: [
                {
                    path: '/payment-archives',
                    name: 'payment-archives',
                    component: () => import('./views/Payment.vue'),
                    // props: (route) => ({
                    //     ...route.params
                    // })
                },
                {
                    path: '/open-buy-archive',
                    name: 'open-buy-archive',
                    component: () => import('./views/Archives/OpenBuy.vue')
                },
                {
                    path: '/open-sell-archive',
                    name: 'open-sell-archive',
                    component: () => import('./views/Archives/OpenSell.vue')
                },
                {
                    path: '/buy-archive',
                    name: 'buy-archive',
                    component: () => import('./views/Archives/BuyArchive.vue')
                },
                {
                    path: '/inventory-archive',
                    name: 'inventory-archive',
                    component: () => import('./views/Archives/InventoryArchive.vue')
                },
                {
                    path: '/receive-archive',
                    name: 'receive-archive',
                    component: () => import('./views/Archives/ReceiveArchive.vue')
                },
                {
                    path: '/payment-archive',
                    name: 'payment-archive',
                    component: () => import('./views/Archives/PaymentArchive.vue')
                },
                {
                    path: '/receive-check-archive',
                    name: 'receive-check-archive',
                    component: () => import('./views/Archives/ReceiveCheckArchive.vue')
                },
                {
                    path: '/payment-check-archive',
                    name: 'payment-check-archive',
                    component: () => import('./views/Archives/PaymentCheckArchive.vue')
                },
                {
                    path: '/sell-archive',
                    name: 'sell-archive',
                    component: () => import('./views/Archives/SellArchive.vue')
                },

            ]
        },
        {
            path: '/initial-balance',
            name: 'initial-balance',
            component: () => import('./views/InitialBalance.vue'),
            children: [
                {
                    path: '/initial-bank',
                    name: 'initial-bank',
                    component: () => import('./views/InitialBalance/Bank.vue')
                },
                {
                    path: '/initial-provider',
                    name: 'initial-provider',
                    component: () => import('./views/InitialBalance/Provider.vue')
                },
                {
                    path: '/initial-customer',
                    name: 'initial-customer',
                    component: () => import('./views/InitialBalance/Customer.vue')
                },
                {
                    path: '/initial-cash-desk',
                    name: 'initial-cash-desk',
                    component: () => import('./views/InitialBalance/CashDesk.vue')
                },
                {
                    path: '/initial-product',
                    name: 'initial-product',
                    component: () => import('./views/InitialBalance/Product.vue')
                },
            ]
        },
        {
            path: '/transactions',
            name: 'transactions',
            component: () => import('./views/Transactions.vue'),
            children: [
                {
                    path: '/transaction-bank',
                    name: 'transaction-bank',
                    component: () => import('./views/Transactions/Bank.vue')
                },
                {
                    path: '/transaction-provider',
                    name: 'transaction-provider',
                    component: () => import('./views/Transactions/Provider.vue')
                },
                {
                    path: '/transaction-customer',
                    name: 'transaction-customer',
                    component: () => import('./views/Transactions/Customer.vue')
                },
                {
                    path: '/transaction-cash-desk',
                    name: 'transaction-cash-desk',
                    component: () => import('./views/Transactions/CashDesk.vue')
                },
                {
                    path: '/transaction-cost',
                    name: 'transaction-cost',
                    component: () => import('./views/Transactions/Cost.vue')
                },
                {
                    path: '/transaction-income',
                    name: 'transaction-income',
                    component: () => import('./views/Transactions/Income.vue')
                },
            ]
        },
        {
            path: '/transaction-payment',
            name: 'transaction-payment',
            component: () => import('./views/Transactions/Payment.vue')
        },
        {
            path: '/income-statement',
            name: 'income-statement',
            component: () => import('./views/IncomeStatement.vue')
        },
        {
            path: '/settings',
            name: 'settings',
            component: () => import('./views/Settings.vue')
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('./views/Login.vue')
        },
        {
            path: '/profile',
            name: 'profile',
            component: () => import('./views/Profile.vue')
        },
        {
            path: '/support',
            name: 'support',
            component: () => import('./views/Support.vue')
        },
        {
            path: '/select-store',
            name: 'select-store',
            component: () => import('./views/SelectStore.vue')
        },
        {
            path: '*',
            name: '404',
            component: () => import('./views/404.vue')
        }
    ]
})
